import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqItems } from '../data/landing';
import { AnimatedSection } from './AnimatedSection';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="border-y border-gray-200 bg-gray-50 py-20 sm:py-24" data-id="element-39" data-mp="1iy1cnu1gsp54">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8" data-id="element-40" data-mp="1nv1l2blse3ze">
        <AnimatedSection data-id="element-41" data-mp="2bk3zlal4jgpo">
          <h2 className="text-3xl font-semibold tracking-[-0.02em] text-gray-950 sm:text-4xl" data-id="element-42" data-mp="2bkvuskat7cff">
            Common questions.
          </h2>
        </AnimatedSection>

        <div className="mt-10 divide-y divide-gray-200 border-y border-gray-200" data-id="element-43" data-mp="21vcd3hyu1om5">
          {faqItems.map((item, index) => {
          const isOpen = openIndex === index;
          return <div key={item.question} data-id="element-44" data-mp="2uiyecjkl8h5u" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} className="flex min-h-16 w-full items-center justify-between gap-4 py-5 text-left font-bold text-gray-950 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-600" aria-expanded={isOpen} aria-controls={`faq-answer-${index}`} data-id="element-45" data-mp="2uhx1qanxbmm0">
                  <span data-id="element-46" data-mp="20p49kf769k4t">{item.question}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-indigo-600 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-47" data-mp="20o2n7ekphb7s" />
                </button>
                {isOpen && <div id={`faq-answer-${index}`} className="pb-6 pr-10 leading-7 text-gray-600" data-id="element-48" data-mp="2oddpj0hpfdo1">
                    {item.answer}
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}